export default __webpack_public_path__ + "static/media/in-house-it-hero.9cc91b89.png";